import { createFileRoute } from '@tanstack/react-router'
import ProjectInspectionNewPage from '@/spa/pages/projects/ProjectInspectionNewPage'
import { routeErrorComponent } from '../../../_shared/RouteError'

export const Route = createFileRoute('/projects/$id/inspections/new')({
  component: ProjectInspectionNewPage,
  errorComponent: routeErrorComponent,
})
